module.exports = __webpack_public_path__ + "img/game.e2e150bc.svg";